module.exports = __webpack_public_path__ + "img/250.c329a0de.jpg";